<template>
  <LoadingWrapper :state="status">
    <BaseTabGroup :tab-items="lessonImpulseTabItems" :default-tab-id="defaultTabId">
      <FullScreenLayoutContentHero>
        <template #hero>
          <div class="flex w-full min-w-0 flex-col">
            <template v-if="!lesson.endedAt">
              <RunningSessionHeader :lesson="lesson" @rename="renameLesson" />
              <LessonImpulseTabBar />
            </template>
            <FinishedSessionHeader v-else :lesson="lesson" @rename="renameLesson" />
          </div>
        </template>
        <LessonImpulseContent
          v-if="!lesson.endedAt"
          :impulse="lesson.lessonImpulse!"
          :show-running-feedback="lesson.feedbackStartedAt !== null"
          :lesson-feedback="{
            running: lesson.feedback != null,
            teams: lesson.teams,
            members: lesson.members,
          }"
        />
        <div v-else>
          <h2 class="text-headline-medium mb-4">{{ $t('lumia.lesson.reflection.title') }}</h2>
          <SelfAssessmentPage />
        </div>
      </FullScreenLayoutContentHero>
    </BaseTabGroup>
  </LoadingWrapper>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseTabGroup from '@/core/components/base/tab-bar/BaseTabGroup.vue'
  import FullScreenLayoutContentHero from '@/core/components/layouts/FullScreenLayoutContentHero.vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useLesson } from '../composables/use-lesson'
  import {
    defaultLessonImpulseTabId,
    useLessonImpulseTabItems,
  } from '../models/lesson-impulse-tabs'
  import LessonImpulseContent from '../components/LessonImpulseContent.vue'
  import LessonImpulseTabBar from '../components/LessonImpulseTabBar.vue'
  import RunningSessionHeader from '../components/RunningSessionHeader.vue'
  import FinishedSessionHeader from '../components/FinishedSessionHeader.vue'
  import SelfAssessmentPage from './SelfAssessmentPage.vue'

  const { lesson, status, renameLesson } = useLesson()
  const lessonImpulseTabItems = useLessonImpulseTabItems()

  const defaultTabId = computed(() => defaultLessonImpulseTabId(lesson.value))
</script>
